module.exports = __webpack_public_path__ + "img/tutor-plan.b0802d20.svg";